import FullscreenMediaPopup from './FullscreenMediaPopup';

export default FullscreenMediaPopup;
